/* ---------------------------------------------------------------------------------------------- */
/*                  ESTE CODIGO SE EJECUTA EN TODAS LAS PAGINAS DE LA APLICACION                  */
/* ---------------------------------------------------------------------------------------------- */

export const ssr = false;
export const prerender = false;